import type { Store } from "@reduxjs/toolkit";
import type { Persistor } from "redux-persist";

import { type PortalState, selectCartItems } from "~/store/portalSlice";

const installPersistorCartFlush = (
	store: Pick<Store<{ portal: PortalState }>, "getState" | "subscribe">,
	persistor: Pick<Persistor, "flush">
) => {
	let lastCart = selectCartItems(store.getState());
	return store.subscribe(() => {
		const cart = selectCartItems(store.getState());
		if (cart === lastCart) return;
		lastCart = cart;
		void persistor.flush();
	});
};

export default installPersistorCartFlush;
